






















































































































import { Links } from '@/mixins/link-mixin';
import { ExtendMixins } from '@/services';
import { required, numeric } from 'vuelidate/lib/validators';
import { exactLength } from '@/validations';
import { getContentArea } from '@/contentful';
import { ContentfulLink } from '@/@types/member';
import { FooterSecondary } from '@/components/global-components/global-footer-component/footer-components';
import { MobileMenuTray } from '@/components/global-components/global-header-component/header-components';
import { EventBus } from '@/event-bus';
import { FormValidation } from '@/mixins';
import { api, MEMBER_API_SUB_URLS } from '@/api';
import { FullscreenSuccess, FullscreenError, FullscreenLoading } from '@/components/fullscreen-wrapper-components';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  showErrorMessage: boolean;
  clientName: string;
  learnLink: ContentfulLink;
  successMessageContent: string;
  zip: string;
  uuid: string;
  otp: string;
  saId: string;
}

export default ExtendMixins(
  FormValidation,
  Links,
).extend({
  name: 'GetSaId',
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      showErrorMessage: false,
      clientName: process.env.VUE_APP_CLIENT_NAME,
      learnLink: null,
      successMessageContent: '',
      zip: '',
      uuid: '',
      otp: '',
      saId: '',
    };
  },
  beforeMount() {
    this.uuid = this.$route.query.uuid;
    this.otp = this.$route.query.otp;
    getContentArea(['global-learn-link', 'get-sa-id-success']).then((data) => {
      const contentAreas = data;
      if (contentAreas) {
        if (contentAreas[0] && contentAreas[0].fields) {
          this.learnLink = this.parseContentfulLink(contentAreas[0].fields);
        }
        if (contentAreas[1] && contentAreas[1].fields) {
          this.successMessageContent = contentAreas[1].fields.content;
        }
      }
    });
  },
  validations: {
      zip: {
        required,
        exactLength: exactLength(5),
        numeric,
      },
  },
  methods: {
    openMobileMenu(): void {
      EventBus.$emit('openMobileMenu');
    },
    register(): void {
      this.$router.push({ name: 'register' });
    },
    login(): void {
      this.$router.push({ name: 'login' });
    },
    contactURL(): string {
      if (this.clientName === 'Vermont') {
        return this.$options.filters.t('login_contact-vermont-url');
      } else if (process.env.VUE_APP_CONTACT_URL) {
        return process.env.VUE_APP_CONTACT_URL;
      }

      return this.$options.filters.t('login_contact-url');
    },
    submitForm(): void {
      // REST-026
      this.isLoading = true;
      const payload = {
        uuid: this.uuid,
        client: 'member_said',
        zipCode: this.zip,
      };
      api
        .post(
          `${MEMBER_API_SUB_URLS.members}/said`,
          payload,
          {
            headers: {
              'x-otp': this.otp,
            },
          },
        )
        .then((response) => {
          this.saId = response.data.spendingAccountID;
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    tryAgain(): void {
      this.showErrorMessage = false;
    },
  },
  computed: {
    successMessage(): string {
      return this.$options.filters.varReplace(this.successMessageContent, {saId: this.saId});
    },
    zipErrors(): string[] {
      const formField = 'zip';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          ['get-sa-id-zip-error-required'],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          ['get-sa-id-zip-error-length'],
          'exactLength',
          {key: 'exactLength', val: 'length'},
        ),
        this.FormValidationMixin.validateField(
          formField,
          ['get-sa-id-zip-error-numeric'],
          'numeric',
        ),
      ]);
    },
  },
  components: {
    FooterSecondary,
    MobileMenuTray,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
